export default function SleighRide() {
  return (
    <div
      data-testid="sleigh-ride"
      aria-hidden="true"
      className="sleigh-track pointer-events-none fixed left-0 top-[14vh] z-40 w-52 sm:w-[420px]"
    >
      <div className="sleigh-bob drop-shadow-[0_0_28px_rgba(255,43,74,0.35)]">
        <svg viewBox="0 -28 660 248" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-auto w-full">
          <defs>
            <linearGradient id="solanaGrad" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#00F5D4" />
              <stop offset="100%" stopColor="#9945FF" />
            </linearGradient>
            <filter id="noseBlur" x="-80%" y="-80%" width="260%" height="260%">
              <feGaussianBlur stdDeviation="5" />
            </filter>

            {/* reindeer (side profile, facing right) */}
            <g id="reindeer">
              <path d="M26 58 Q14 52 12 42" stroke="#8B5A2B" strokeWidth="6" strokeLinecap="round" fill="none" />
              <path d="M44 76 L32 92 L38 102" stroke="#6B3F1D" strokeWidth="7" strokeLinecap="round" fill="none" />
              <path d="M76 78 L84 96 L76 104" stroke="#6B3F1D" strokeWidth="7" strokeLinecap="round" fill="none" />
              <ellipse cx="60" cy="64" rx="34" ry="21" fill="#8B5A2B" />
              <ellipse cx="60" cy="71" rx="25" ry="12" fill="#9C6B33" />
              <rect x="82" y="28" width="19" height="36" rx="9" transform="rotate(18 92 46)" fill="#8B5A2B" />
              <g transform="rotate(12 110 24)">
                <rect x="94" y="14" width="34" height="21" rx="10" fill="#9C6B33" />
                <ellipse cx="126" cy="27" rx="9" ry="8" fill="#9C6B33" />
              </g>
              <path d="M100 14 Q103 4 110 12 Z" fill="#6B3F1D" />
              <path
                d="M110 12 C108 2 102 -4 92 -6 M104 4 C100 0 96 0 92 4 M101 -2 C97 -4 93 -2 91 2"
                stroke="#4A2E14"
                strokeWidth="3.5"
                strokeLinecap="round"
                fill="none"
              />
              <path d="M116 13 C116 4 112 -2 104 -5" stroke="#4A2E14" strokeWidth="3" strokeLinecap="round" fill="none" opacity="0.7" />
              <circle cx="112" cy="22" r="2.6" fill="#111827" />
              <path d="M86 76 L100 92 L94 102" stroke="#8B5A2B" strokeWidth="7" strokeLinecap="round" fill="none" />
              <path d="M50 78 L40 94 L46 104" stroke="#8B5A2B" strokeWidth="7" strokeLinecap="round" fill="none" />
              <circle cx="98" cy="44" r="4" fill="#FFD700" />
            </g>
          </defs>

          {/* speed lines + sparkle trail behind sleigh */}
          <line x1="4" y1="120" x2="34" y2="120" stroke="#00F5D4" strokeWidth="3" strokeLinecap="round" opacity="0.5" />
          <line x1="10" y1="136" x2="30" y2="136" stroke="#FF2B4A" strokeWidth="3" strokeLinecap="round" opacity="0.5" />
          <circle cx="18" cy="96" r="3.5" fill="#FFD700" className="twinkle-star" />
          <circle cx="36" cy="72" r="2.5" fill="#00F5D4" className="twinkle-star" style={{ animationDelay: "0.6s" }} />
          <circle cx="8" cy="150" r="2.5" fill="#F8FAFC" className="twinkle-star" style={{ animationDelay: "1.1s" }} />

          {/* gold runner */}
          <path
            d="M24 168 Q64 188 168 180 Q256 174 292 150 Q302 143 297 136"
            stroke="#FFD700"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <line x1="78" y1="152" x2="74" y2="172" stroke="#FFD700" strokeWidth="5" strokeLinecap="round" />
          <line x1="238" y1="152" x2="244" y2="172" stroke="#FFD700" strokeWidth="5" strokeLinecap="round" />

          {/* sleigh hull */}
          <path
            d="M38 94 C42 130 72 150 112 150 L242 150 C270 150 286 128 290 98 L298 88 L288 80 C283 96 268 106 246 106 L68 106 C54 106 42 102 38 94 Z"
            fill="#C8102E"
          />
          <path d="M46 96 Q76 112 160 112 L248 112" stroke="#FFD700" strokeWidth="4" strokeLinecap="round" />
          <circle cx="38" cy="92" r="8" fill="#FFD700" />

          {/* santa */}
          <rect x="74" y="56" width="54" height="54" rx="22" fill="#E11D2E" />
          <rect x="74" y="88" width="54" height="9" fill="#111827" />
          <rect x="96" y="86" width="12" height="13" rx="2" fill="#FFD700" />
          <circle cx="101" cy="44" r="16" fill="#FFD9B3" />
          <circle cx="101" cy="56" r="12" fill="#F8FAFC" />
          <circle cx="120" cy="52" r="7" fill="#F8FAFC" />
          <path d="M85 36 Q101 6 120 28 Q112 22 103 24 Q92 26 85 36 Z" fill="#E11D2E" />
          <rect x="82" y="30" width="38" height="9" rx="4.5" fill="#F8FAFC" />
          <circle cx="121" cy="12" r="6.5" fill="#F8FAFC" />

          {/* solana stocking hanging on sleigh front */}
          <g transform="rotate(8 240 70)">
            <rect x="222" y="34" width="36" height="15" rx="7" fill="#F8FAFC" />
            <path
              d="M225 47 L225 88 Q225 100 237 102 L258 106 Q270 108 268 95 Q267 87 256 85 L244 83 L244 47 Z"
              fill="#E11D2E"
            />
            <path d="M228 56 L241 56 L238 61 L225 61 Z" fill="url(#solanaGrad)" />
            <path d="M228 64 L241 64 L238 69 L225 69 Z" fill="url(#solanaGrad)" opacity="0.85" />
            <path d="M228 72 L241 72 L238 77 L225 77 Z" fill="url(#solanaGrad)" opacity="0.7" />
          </g>

          {/* harness ropes */}
          <path d="M292 96 Q350 112 388 122" stroke="#FFD700" strokeWidth="2.5" strokeLinecap="round" opacity="0.9" />
          <path d="M392 121 Q440 112 486 100" stroke="#FFD700" strokeWidth="2.5" strokeLinecap="round" opacity="0.9" />
          <path d="M490 99 Q544 88 594 76" stroke="#FFD700" strokeWidth="2.5" strokeLinecap="round" opacity="0.9" />

          {/* reindeer team */}
          <use href="#reindeer" transform="translate(312,88) scale(0.8)" />
          <use href="#reindeer" transform="translate(404,60) scale(0.88)" />
          <use href="#reindeer" transform="translate(500,30)" />

          {/* trailing reindeer noses */}
          <circle cx="418" cy="110" r="4.2" fill="#3A2410" />
          <circle cx="520" cy="84" r="4.6" fill="#3A2410" />

          {/* lead reindeer solana nose */}
          <circle cx="632" cy="57" r="11" fill="#00F5D4" opacity="0.35" filter="url(#noseBlur)" className="twinkle-star" />
          <circle cx="632" cy="57" r="6" fill="url(#solanaGrad)" style={{ filter: "drop-shadow(0 0 6px #00F5D4)" }} />
        </svg>
      </div>
    </div>
  );
}
